module.exports = __webpack_public_path__ + "img/mind_skeleton_22.db9102cd.png";